// test1566
(1566 && 0);
